import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson13: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson12"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Self Coaching</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson14"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[6.25rem] text-justify text-gainsboro-100 font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>Importance of The Self Coaching?</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">{`In the intricate symphony of human existence, our bodies dance to the rhythm of nature's orchestra. Deep within us lies a remarkable internal clock known as the circadian rhythm, guiding the ebb and flow of our biological processes. `}</p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              From the moment we emerge into this world, this innate rhythm
              orchestrates our sleep-wake cycles, hormone production,
              metabolism, and overall physiological well-being. Understanding
              and honouring the delicate balance of our circadian rhythm can
              hold the key to unlocking optimal health, vitality, and emotional
              well-being.
            </p>
          </div>
          <img
            className="relative w-[28.44rem] h-[25.13rem] object-cover"
            alt=""
            src="/26@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-white">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>How to Embrace The Rhythms of The Circadian Clock:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`Establish a Consistent Sleep Routine: `}</b>
                  <span>
                    One of the foundational pillars of maintaining a healthy
                    circadian rhythm is establishing a regular sleep routine.
                    Aim to go to bed and wake up at the same time every day,
                    even on weekends. This consistency helps regulate your
                    body's internal clock and promotes quality sleep, leading to
                    increased energy levels and improved overall well-being.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`Maximize Exposure to Natural Light: `}</b>
                  <span>
                    Expose yourself to natural light, especially in the morning.
                    Step outside or open your curtains to let the gentle rays of
                    the sun touch your skin. This exposure to natural light
                    early in the day helps synchronize your circadian clock,
                    promoting alertness, mental clarity, and a balanced mood.
                    Spend time outdoors during daylight hours to enhance the
                    alignment with the natural light-dark cycle.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Limit Artificial Light Exposure at Night:</b>
                  <span>
                    {" "}
                    In the evening hours leading up to bedtime, minimize
                    exposure to artificial light sources that emit blue light,
                    such as smartphones, tablets, and computer screens. Blue
                    light can disrupt the production of melatonin, a hormone
                    that regulates sleep. Instead, opt for dimmer lighting or
                    warm-toned bulbs in your home environment to signal to your
                    body that it is time to wind down.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`Engage in Regular Physical Activity: `}</b>
                  <span>
                    Regular exercise not only promotes physical fitness but also
                    helps regulate the circadian rhythm. Aim for at least 30
                    minutes of moderate-intensity exercise most days of the
                    week, preferably during daylight hours. Physical activity
                    can enhance the synchronization of your internal clock,
                    leading to improved sleep quality and overall circadian
                    rhythm regulation.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Practice Mindfulness and Relaxation Techniques:</b>
                  <span>
                    {" "}
                    Incorporate mindfulness and relaxation practices into your
                    daily routine to help reduce stress and support a healthy
                    circadian rhythm. Techniques such as meditation, deep
                    breathing exercises, and gentle stretching can help calm the
                    mind, promote relaxation, and prepare your body for restful
                    sleep.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`Create a Sleep-Friendly Environment: `}</b>
                  <span>
                    Ensure that your sleep environment is conducive to
                    restorative sleep. Keep your bedroom cool, quiet, and dark
                    to promote optimal sleep conditions. Consider using blackout
                    curtains, earplugs, or white noise machines to create a
                    peaceful sanctuary that supports your circadian rhythm.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`Limit Caffeine and Stimulant Intake: `}</b>
                  <span>
                    Be mindful of your caffeine and stimulant consumption,
                    particularly in the afternoon and evening hours. Caffeine
                    has a stimulatory effect that can interfere with sleep
                    quality and disrupt the natural circadian rhythm. Opt for
                    caffeine-free herbal teas or decaffeinated alternatives as
                    the day progresses to support a healthy sleep-wake cycle.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`Establish Regular Meal Times: `}</b>
                  <span>
                    In addition to sleep, the circadian clock also influences
                    our metabolism and digestion. Aim to establish regular meal
                    times and avoid eating heavy meals close to bedtime.
                    Providing your body with consistent nourishment at regular
                    intervals can help regulate your circadian rhythm and
                    promote a healthy digestive system.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0 text-orangered-100">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <p className="m-0">
            <b>
              <span>Conclusion:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                As we journey through life, embracing the inherent rhythms of
                our circadian clock becomes paramount to our well-being. By
                implementing these habits and aligning ourselves with the
                natural cycles of light and darkness, we can foster a strong
                connection with our internal timekeeper. Let us embrace the
                wisdom of the circadian clock, allowing it to guide us towards
                optimal health, vitality, and a profound sense of balance in our
                daily lives.
              </span>
            </span>
          </p>
        </div>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson14"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson13;
